export function createEventType(_a) {
    var _b = _a.id, id = _b === void 0 ? null : _b, _c = _a.name, name = _c === void 0 ? null : _c;
    return {
        id: id,
        name: name,
    };
}
